import { useThemeConfigContext } from 'contexts/ThemeConfigContext';
import { LegalConfig } from 'types/legal';

/**
 * Theme configuration interface for customizing login page appearance and behavior
 */
export interface ThemeConfig {  /** Brand name to display */
  name?: string;
  /** Logo configuration */
  icons?: {
    logo_path?: {
      /** URL path to the logo image */
      url?: string;
    };
    logo_light_path?: {
      /** URL path to the light mode logo image */
      url?: string;
    };
    fav_icon_path?: {
      /** URL path to the favicon image */
      url?: string; 
    };
    square_logo_path?: {
      /** URL path to the square logo image */
      url?: string; 
    };
  };
  /** Custom label for email field */
  emailLabel?: string;
  /** Custom placeholder for email field */
  emailPlaceholder?: string;
  /** Custom label for password field */
  passwordLabel?: string;
  /** Custom placeholder for password field */
  passwordPlaceholder?: string;
  /** Custom text for forgot password link */
  forgotPasswordText?: string;
  /** Custom text for login button */
  loginButtonText?: string;
  /** Custom text for Microsoft login button */
  entraIdButtonText?: string;
  /** Authentication method configuration */
  clientConfig?: {
    usernamePassword?: {
      enabled: boolean;
    };
    otp?: {
      enabled: boolean;
    };
    entraId?: {
      enabled: boolean;
    };
  };
  /** Microsoft authentication configuration */
  microsoftAuth?: {
    clientId?: string;
    tenantId?: string;
  };
  /** Login consent checkboxes and current legal documents; null when not configured */
  legal?: LegalConfig | null;
}

export interface ColorPalette {
  primary: string;
  primary_dark: string;
  accent: string;
  accent_dark: string;
  secondary: string;
  secondary_dark: string;
  text_color: string;
  text_color_light: string;
}

interface UseThemeConfigReturn {
  colorConfig: ColorPalette | null;
  themeConfig: ThemeConfig | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

/**
 * Hook to access theme configuration from context
 * This ensures the API is only called once and the result is cached
 */
const useThemeConfig = (): UseThemeConfigReturn => {
  console.log('🎨 [useThemeConfig] Hook called - returning cached data from context');
  return useThemeConfigContext();
};

export default useThemeConfig;